export default __webpack_public_path__ + "static/media/Filter.f3d8ba65.svg";